import { ClearNotification, ShowNotification, TypeKeys } from "./types";

export const showNotification = (text: string, subText: string): ShowNotification => ({
    type: TypeKeys.SHOW_NOTIFICATION,
    text,
    subText,
});

export const clearNotification = (): ClearNotification => ({
    type: TypeKeys.CLEAR_NOTIFICATION,
});

export type ActionTypes = ShowNotification | ClearNotification;